import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { CommonProps } from '../../helpers/props';
import useProgressStore from 'src/hooks/useProgressStore';
import ModalPortal from 'src/shared/react-utils/ModalPortal';

import './index.scss';
import { ProgressIcon } from 'fasoo-ui-component-next';
import usePreventScrollStore from 'src/hooks/usePreventScroll';

interface ProgressProps extends CommonProps {
  inProgress: boolean;
}

const Progress: React.FC<ProgressProps> = ({ classes, inProgress }) => {
  const { startPreventScroll, stopPreventScroll } = usePreventScrollStore();
  useEffect(() => {
    if (inProgress) {
      startPreventScroll();
    } else {
      stopPreventScroll();
    }
  }, [inProgress]);
  return (
    <ModalPortal>
      {/* <div className={classNames('progress-backdrop-root', { on: inProgress })} /> */}
      <div
        className={classNames(
          'progress-root',
          {
            on: inProgress,
          },
          classes
        )}
      >
        {inProgress && <ProgressIcon productType="fxmMobile" />}
      </div>
    </ModalPortal>
  );
};

export default Progress;
